import { createFeatureSelector } from "@ngrx/store";

import { UsersState } from "../models/users-state";
import { StoreKeys } from "../store-keys";

export class UsersSelectors {
	static readonly users = createFeatureSelector<UsersState>(StoreKeys.usersStateKey);
}
